import { skipToken, useQuery } from "@tanstack/react-query";
import { getMerchantsPublicIDOrbitLStatus } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const ORBIT_L_STATUS_QUERY_KEY = "ORBIT_L_STATUS";

export const orbitLStatusKeys = {
  all: [ORBIT_L_STATUS_QUERY_KEY],
  byMerchantPublicId: (merchantPublicID?: string) => [
    ...orbitLStatusKeys.all,
    merchantPublicID,
  ],
};

export const useGetOrbitLStatusQuery = (
  merchantPublicID?: string,
  enabled = true,
) =>
  useQuery({
    queryKey: orbitLStatusKeys.byMerchantPublicId(merchantPublicID),
    queryFn: merchantPublicID
      ? processResponseWithApiProblemDetails(() =>
          getMerchantsPublicIDOrbitLStatus(merchantPublicID),
        )
      : skipToken,
    enabled,
  });
